import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
export function SidebarTopLevel({ href, icon, label, badge, badgeTitle, active = false, disabled = false, disabledLabel, onClick, indent = false, }) {
    const [hovered, setHovered] = useState(false);
    const sharedStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--sp-2)',
        minHeight: 36,
        /* No group indent — flush with group headers at --sp-3 (sub-items nest by --sp-6). */
        padding: indent ? '0 var(--sp-3) 0 var(--sp-6)' : '0 var(--sp-3)',
        margin: '0 var(--sp-2)',
        borderRadius: 'var(--radius-sm)',
        fontSize: 'var(--fs-sm)',
        fontFamily: 'inherit',
        fontWeight: active ? 600 : 500,
        textDecoration: 'none',
        position: 'relative',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? 'none' : undefined,
        color: active ? 'var(--accent-soft-text)' : 'var(--text-muted)',
        background: active
            ? 'var(--accent-soft)'
            : hovered
                ? 'var(--surface-alt)'
                : 'transparent',
    };
    const content = (_jsxs(_Fragment, { children: [active ? (_jsx("span", { "aria-hidden": "true", style: {
                    position: 'absolute',
                    left: 0,
                    top: '20%',
                    bottom: '20%',
                    width: 3,
                    borderRadius: 2,
                    background: 'var(--accent)',
                } })) : null, icon ? (_jsx("span", { "aria-hidden": "true", style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 18,
                    height: 18,
                    flexShrink: 0,
                    color: active ? 'var(--accent-soft-text)' : 'var(--text-dim)',
                }, children: icon })) : null, _jsx("span", { style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    flex: 1,
                    minWidth: 0,
                }, children: label }), disabled && disabledLabel ? (_jsx("span", { style: {
                    fontSize: 'var(--fs-xs)',
                    fontStyle: 'italic',
                    color: 'var(--text-dim)',
                    marginLeft: 'auto',
                    flexShrink: 0,
                }, children: disabledLabel })) : null, badge != null && !disabled ? (_jsx("span", { title: badgeTitle, style: {
                    fontSize: '0.7rem',
                    fontWeight: 600,
                    background: 'var(--surface-alt)',
                    color: 'var(--text-muted)',
                    padding: '0 6px',
                    borderRadius: 10,
                    marginLeft: 'auto',
                    flexShrink: 0,
                    lineHeight: '18px',
                }, children: badge })) : null] }));
    if (disabled) {
        return (_jsx("div", { style: { listStyle: 'none' }, children: _jsx("span", { style: sharedStyle, children: content }) }));
    }
    return (_jsx("div", { style: { listStyle: 'none' }, children: _jsx("a", { href: href, onClick: onClick, "aria-current": active ? 'page' : undefined, onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), style: sharedStyle, children: content }) }));
}
//# sourceMappingURL=SidebarTopLevel.js.map